import { Injectable } from '@angular/core';

@Injectable()
export class ColorsService {

    APP_COLORS = {
          'primary':                '#0a1f3c',
          'success':                '#4CAF50',
          'info':                   '#0068a7',
          'warning':                '#ee733c',
          'danger':                 '#df1b24',
          'inverse':                '#607D8B',
          'green':                  '#009688',
          'pink':                   '#E91E63',
          'purple':                 '#673AB7',
          'dark':                   '#0a1f3c',
          'yellow':                 '#fff000',
          'gray-darker':            '#232735',
          'gray-dark':              '#3a3f51',
          'gray':                   '#dde6e9',
          'gray-light':             '#e4eaec',
          'gray-lighter':           '#edf1f2'
    };

    constructor() { }

    byName(name) {
        // console.log(name +' -> ' + this.APP_COLORS[name])
        return (this.APP_COLORS[name] || '#fff');
    }

}
